__turbopack_context__.v({
  "className": "poppins_216db6f2-module__WXhzdq__className",
  "variable": "poppins_216db6f2-module__WXhzdq__variable",
});
